import { areAttachmentsFullyRejected } from '@views/ProofDocuments/utils/useAreDocumentsReady';
import { REQUISITION } from '@config/constants';
import { DOCUMENT_STATUS, getDocumentTypesData } from '../utils';

const getStatus = (documents, areGroupDocsReady, areGroupDocsApproved) => {
  if (documents?.length === 0) return DOCUMENT_STATUS.INITIAL;

  if (areGroupDocsApproved) return DOCUMENT_STATUS.APPROVED;

  if (areGroupDocsReady) return DOCUMENT_STATUS.PENDING;

  if (
    documents?.some((document) => document.status === DOCUMENT_STATUS.REJECTED)
    || documents?.some((document) => areAttachmentsFullyRejected(document))
  ) {
    return DOCUMENT_STATUS.REJECTED;
  }

  return DOCUMENT_STATUS.INITIAL;
};

const getDocumentConfig = ({
  preferred,
  documents,
  notPreferred,
  areGroupDocsReady,
  areGroupDocsApproved,
}) => {
  const status = getStatus(documents, areGroupDocsReady, areGroupDocsApproved);
  const isStatusInitial = status === DOCUMENT_STATUS.INITIAL;
  const isStatusPending = status === DOCUMENT_STATUS.PENDING;
  const isStatusApproved = status === DOCUMENT_STATUS.APPROVED;
  const isStatusWarning = status === DOCUMENT_STATUS.REJECTED;

  const isPreferred = preferred && isStatusInitial && !notPreferred;
  const showPendingImage = isStatusWarning || isStatusInitial;
  const showCompleteImage = isStatusPending || isStatusApproved;
  const showUploadDocumentButton = isStatusInitial || isStatusWarning;
  const showIDontHaveItButton = isStatusInitial;
  const showEditUploadedDocumentButton = isStatusPending;

  return {
    isPreferred,
    isStatusWarning,
    showPendingImage,
    showCompleteImage,
    showIDontHaveItButton,
    showUploadDocumentButton,
    showEditUploadedDocumentButton,
  };
};

export const useController = ({
  type,
  documents,
  notPreferred,
  missingCount,
  uploadedCount,
  areGroupDocsReady,
  uploadedDocuments,
  requisitionStatus,
  areGroupDocsApproved,
}) => {
  const partialCardData = getDocumentTypesData(type);

  const { preferred } = partialCardData || false;

  const cardConfig = getDocumentConfig({
    preferred,
    documents,
    notPreferred,
    areGroupDocsReady,
    uploadedDocuments,
    areGroupDocsApproved,
  });

  const cardData = {
    ...partialCardData,
    ...cardConfig,
    uploadedDocuments,
  };

  const displayUploadedFilesAlert = [
    requisitionStatus !== REQUISITION.STATUS.ANALYSIS_MISSING_DOCS,
    uploadedCount > 0,
    !cardData.showEditUploadedDocumentButton,
  ].every(Boolean);
  const displayMissingFilesAlert = [
    requisitionStatus !== REQUISITION.STATUS.ANALYSIS_MISSING_DOCS,
    uploadedCount > 0,
    missingCount > 0,
    !cardData.showEditUploadedDocumentButton,
  ].every(Boolean);

  return {
    cardData,
    displayUploadedFilesAlert,
    displayMissingFilesAlert,
  };
};
